// ESM-Huelle fuer lib/scripts/components/CMP_CRow.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CRow (id)
{
    this.construct (id);

    this.name = "CRow";    
    this.htmlType = "tr";

    this.properties =
    {
        styles: {},
        events: {},
        attributes: {}
    }
}

CRow.prototype = new CComponent;
export { CRow };
